export class CountriesModel {
  _id: any
  countryName: any
}
export class StatesModel {
  _id: any
  stateName: any
}
export class UserDetailsModel {
  username: string;
  organization_name: String;
  organization_title: String;
  phone: String;
  ext: String;
  city: String;
  address: String;
  country: CountriesModel;
  state: StatesModel;
  postal_code: String;
  bgImage: String;
  logo: String;
  caption: String;
  constructor() {
    this.country = new CountriesModel();
    this.state = new StatesModel();
  }
}
